// extracted by mini-css-extract-plugin
export default {"hero__con":"styles_hero__con__ODMZC","bgScale":"styles_bgScale__wtRNd","content":"styles_content__4HSeZ","rtl":"styles_rtl__NZAEM","btn":"styles_btn__3GNvE"};